import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from "@heroicons/react/24/outline";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import Kvkk from "./Kvkk";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import emailjs from "emailjs-com";
import toast from "react-hot-toast";

//service_qeibfry
//3jJue0JZTm3ggCDe5
export default function Contact() {
  const { t, i18n } = useTranslation();
  const [acceptedKVKK, setAcceptedKVKK] = useState(false);
  const [errorKVKK, setErrorKVKK] = useState(false);
  const [isKvkkModalOpen, setIsKvkkModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 1500, easing: "ease-out", once: true });
  }, []);

  const ContactSchema = Yup.object().shape({
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    phone: Yup.string().required(),
    email: Yup.string().email().required(),
    message: Yup.string().required(),
  });

  const handleSubmit = async (values, actions) => {
    if (!acceptedKVKK) {
      setErrorKVKK(true)
      return;
    }
    sendEmail(values);
    actions.resetForm();
  };



  const sendEmail = (values) => {
    const templateParams = {
      from_name: `${values.firstName} ${values.lastName}`,
      from_email: values.email,
      message: values.message,
      phone: values.phone
    };

    emailjs
      .send(
        "service_qeibfry",
        "template_4gvrl8f",
        templateParams,
        "3jJue0JZTm3ggCDe5"
      )
      .then(
        (result) => {
          console.log("Başarılı:", result.text);
          toast.success(`${t("formSuccess")}`)
        },
        (error) => {
          console.error("Hata:", error.text);
          toast.error(`${t("formError")}`)
        }
      );
  };


  const openKvkkModal = () => setIsKvkkModalOpen(true);
  const closeKvkkModal = () => setIsKvkkModalOpen(false);
  const isHomePage = location.pathname === "/";

  return (
    <>
      <Navbar />
      <div className="relative isolate overflow-hidden bg-[#1f1f2c] py-8 sm:py-12 md:py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-12 lg:max-w-none lg:grid-cols-2">

            {/* İletişim Bilgileri */}
            <div className="max-w-xl lg:max-w-lg" data-aos="fade" data-aos-delay="300">
              <h2 className="text-2xl sm:text-3xl  font-aventa tracking-tight text-[#dcbc5c] mt-20"aria-label="İletişim">
                {t("contactheader1")}
              </h2>
              <p className="mt-2 text-base text-white/80 sm:text-lg "data-aos="fade" data-aos-delay="400"aria-label="bizimle iletişime geçin">
                {t("contactheader2")}
              </p>

              <div className="mt-6 flex flex-col gap-6 sm:gap-8">
                <div className="flex items-center space-x-4"data-aos="fade" data-aos-delay="500">
                  <div className="flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all" data-aos="fade" data-aos-delay="500">
                    <PhoneIcon className="h-5 w-5 text-white" />
                  </div>
                  <a href="tel:+905333600068" className="text-base text-white hover:text-[#dcbc5c]" aria-label="telefon">
                    +90 533 360 0068
                  </a>
                </div>

                <div className="flex items-center space-x-4" data-aos="fade" data-aos-delay="600">
                  <div className="flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all">
                    <EnvelopeIcon className="h-5 w-5 text-white" />
                  </div>
                  <a href="mailto:edakarakisla@junyazilim.com" className="text-base text-white hover:text-[#dcbc5c]"aria-label="mail">
                    info@junyazilim.com
                  </a>
                </div>

                <div className="flex items-center space-x-4"data-aos="fade" data-aos-delay="700">
                  <div className="flex items-center justify-center rounded-md bg-white/5 p-2 ring-1 ring-white/10 hover:ring-[#dcbc5c] transition-all">
                    <MapPinIcon className="h-5 w-5 text-white" />
                  </div>
                  <span className="text-white text-base hover:text-[#dcbc5c]"aria-label="İstanbul">İstanbul, Türkiye</span>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="mt-8 lg:mt-10">
              <div className="bg-gradient-to-r from-[#36364d] to-[#1f1f2c] p-6 rounded-lg shadow-lg "data-aos="fade" data-aos-delay="700">
                <Formik
                  initialValues={{ firstName: "", lastName: "", phone: "", email: "", message: "" }}
                  validationSchema={ContactSchema}
                  onSubmit={handleSubmit}
                >
                  {({ errors, touched }) => (
                    <Form className="space-y-4">
                      <div className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
                        <div>
                          <label className="text-sm text-white">{t("formisim")}</label>
                          <Field
                            name="firstName"
                            placeholder={t("formisim")}
                            className={`mt-1 block w-full rounded-md px-3 py-2 bg-white/5 text-white border-2 focus:outline-none ${errors.firstName && touched.firstName ? "border-red-900" : "border-indigo-200"
                              }`}
                          />
                        </div>
                        <div>
                          <label className="text-sm text-white">{t("formsoyisim")}</label>
                          <Field
                            name="lastName"
                            placeholder={t("formsoyisim")}
                            className={`mt-1 block w-full rounded-md px-3 py-2 bg-white/5 text-white border-2 focus:outline-none ${errors.lastName && touched.lastName ? "border-red-900" : "border-indigo-200"
                              }`}
                          />
                        </div>
                      </div>

                      <div>
                        <label className="text-sm text-white">{t("formtelefon")}</label>
                        <Field
                          name="phone"
                          placeholder={t("formtelefon")}
                          className={`mt-1 block w-full rounded-md px-3 py-2 bg-white/5 text-white border-2 focus:outline-none ${errors.phone && touched.phone ? "border-red-900" : "border-indigo-200"
                            }`}
                        />
                      </div>

                      <div>
                        <label className="text-sm text-white">{t("formmail")}</label>
                        <Field
                          name="email"
                          type="email"
                          placeholder={t("formmail")}
                          className={`mt-1 block w-full rounded-md px-3 py-2 bg-white/5 text-white border-2 focus:outline-none ${errors.email && touched.email ? "border-red-900" : "border-indigo-200"
                            }`}
                        />
                      </div>

                      <div>
                        <label className="text-sm text-white">{t("formmesaj")}</label>
                        <Field
                          name="message"
                          as="textarea"
                          rows="4"
                          placeholder={t("formmesaj")}
                          className={`mt-1 block w-full rounded-md px-3 py-2 bg-white/5 text-white border-2 focus:outline-none ${errors.message && touched.message ? "border-red-900" : "border-indigo-200"
                            }`}
                        />
                      </div>

                      {/* KVKK */}
                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          id="kvkk-accept"
                          checked={acceptedKVKK}
                          onChange={() => {
                            setAcceptedKVKK(!acceptedKVKK);
                            if (errorKVKK) setErrorKVKK(false);
                          }}
                          className="hidden"
                        />
                        <div
                          className={`w-5 h-5 border-2 border-white/40 rounded-full cursor-pointer ${acceptedKVKK ? "bg-[#dcbc5c] border-[#dcbc5c]" : "bg-transparent"}`}
                          onClick={() => {
                            setAcceptedKVKK(!acceptedKVKK);
                            if (errorKVKK) setErrorKVKK(false);
                          }}
                        >
                          {acceptedKVKK && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full text-white"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M20 6L9 17l-5-5" />
                            </svg>
                          )}
                        </div>
                        <label htmlFor="kvkk-accept" className={`text-sm ${errorKVKK ? "text-red-500" : "text-white"}`}>
                          <span
                            className={`cursor-pointer ${i18n.language === "tr" ? "underline" : ""}`}
                            onClick={openKvkkModal}
                          >
                            {t("kvkk.linkText")}
                          </span>
                          {i18n.language === "en" ? (
                            <span className="underline">{t("kvkk.label")}</span>
                          ) : (
                            t("kvkk.label")
                          )}
                        </label>
                      </div>


                      <div>
                        <button
                          type="submit"
                          className="w-full rounded-md bg-[#1f1f2c] px-4 py-2 text-white font-semibold hover:bg-[#1f1f2c] focus:ring-2 focus:ring-white"
                        >
                          {t("formbuton")}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!isHomePage && <Footer />}
      {isKvkkModalOpen && <Kvkk closeModal={closeKvkkModal} />}
    </>
  );
}
